import React from 'react';
import { FileCheck, Shield, Award, TreePine, Leaf, FileText } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { SectionHeader } from './shared/SectionHeader';

const certIcons = [FileCheck, Shield, Award, TreePine, Leaf, FileText];

export default function CertificationGallery() {
  const { t } = useLanguage();
  const certs = t('certifications.certs');

  return (
    <section id="certifications" className="py-24 md:py-32 bg-slate-50" data-testid="certifications-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader label={t('certifications.sectionLabel')} title={t('certifications.title')} subtitle={t('certifications.subtitle')} />

        <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
          {Array.isArray(certs) && certs.map((cert, i) => {
            const Icon = certIcons[i] || FileCheck;
            return (
              <div
                key={cert.name}
                className="bg-white border border-slate-100 p-8 text-center group hover:border-brand-green transition-all duration-300"
                data-testid={`cert-card-${i}`}
              >
                <div className="w-16 h-16 mx-auto mb-6 bg-brand-green/5 flex items-center justify-center group-hover:bg-brand-green transition-colors duration-300">
                  <Icon className="w-8 h-8 text-brand-green group-hover:text-white transition-colors duration-300" />
                </div>
                <h4 className="font-heading text-lg font-bold text-slate-900 mb-2">{cert.name}</h4>
                <p className="text-slate-500 text-sm leading-relaxed">{cert.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
